// File: components/transformationSection/TransformationSection.jsx

import React from "react";
import "./TransformationSection.css";

import {
  Lightbulb,
  BookOpen,
  Globe
} from "lucide-react";

export default function TransformationSection() {

  const transformationData = [
    {
      icon: <Lightbulb size={42} />,
      title: "Concept to Manuscript",
      description:
        "Turn your ideas into a compelling, well-structured manuscript with our expert guidance."
    },
    {
      icon: <BookOpen size={42} />,
      title: "Manuscript to Book Deal",
      description:
        "Navigate the publishing industry to secure book deals with leading publishers."
    },
    {
      icon: <Globe size={42} />,
      title: "Book to Worldwide Reach",
      description:
        "Expand your book into an IP ecosystem to reach a global audience and create lasting impact."
    }
  ];

  return (
    <section className="transformation-section">

      {/* NEW BACKGROUND LAYER */}
      <div className="transformation-bg"></div>

      <div className="transformation-container">

        <div className="transformation-header">
          <h2>Transform Your Ideas into Published Works.</h2>
        </div>

        <div className="transformation-grid">

          {transformationData.map((item, index) => (
            <div className="transformation-card" key={index}>

              <div className="transformation-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
}